var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDarthSidiusLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0dsl{fill:#791615;}\r\n\t.st1dsl{fill:#D8D8D8;}\r\n\t.st2dsl{fill:#C2C1C1;}\r\n\t.st3dsl{fill:#333333;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lag_1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0dsl",
    cx: 150,
    cy: 150.3,
    r: 150
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_5"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_2"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_3"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_4"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_6"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1dsl",
    d: "M212.7,118.8c-20.9-14.1-41.8-28.2-62.7-42.2c-20.9,14.1-41.8,28.2-62.7,42.2c-0.5,29.7-1,59.5-1.5,89.2 c4,2.8,20,13,40.8,9.7c11-1.7,18.9-6.5,23.4-9.7c4.4,3.2,12.4,8,23.4,9.7c20.8,3.3,36.7-7,40.8-9.7 C213.6,178.3,213.1,148.5,212.7,118.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2dsl",
    d: "M151.8,138.1h-0.1c-0.7,0-1.2-0.5-1.2-1.2V94.5c0-0.7,0.5-1.2,1.2-1.2h0.1c0.7,0,1.2,0.5,1.2,1.2v42.4 C153,137.5,152.4,138.1,151.8,138.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2dsl",
    d: "M150.4,121.5c0-0.7,0.6-1.3,1.4-1.3c5.7-1.6,14-3.2,24.1-3.2c10.2,0,18.6,1.7,24.4,3.2c0.1,0,0.6,0,1,0.4 c0.3,0.2,0.4,0.5,0.4,0.9c0,0.7-0.6,1.3-1.4,1.3c-5.6-1.6-14-3.4-24.3-3.4c-10.3,0-18.7,1.8-24.3,3.4 C151,122.6,150.4,122,150.4,121.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2dsl",
    d: "M100.4,121.5c0-0.7,0.6-1.3,1.4-1.3c5.7-1.6,14-3.2,24.1-3.2c10.2,0,18.6,1.7,24.4,3.2c0.1,0,0.6,0,1,0.4 c0.3,0.2,0.4,0.5,0.4,0.9c0,0.7-0.6,1.3-1.4,1.3c-5.6-1.6-14-3.4-24.3-3.4c-10.3,0-18.7,1.8-24.3,3.4 C101,122.6,100.4,122,100.4,121.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2dsl",
    d: "M149.4,136.8c0-0.7,0.7-1.3,1.6-1.3c6.5-1.6,16-3.2,27.5-3.2c11.7,0,21.2,1.7,27.8,3.2c0.1,0,0.7,0,1.1,0.4 c0.3,0.2,0.5,0.5,0.5,0.9c0,0.7-0.7,1.3-1.6,1.3c-6.4-1.6-15.9-3.4-27.7-3.4c-11.7,0-21.3,1.8-27.7,3.4 C150.1,137.9,149.4,137.4,149.4,136.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2dsl",
    d: "M92.3,136.8c0-0.7,0.7-1.3,1.7-1.3c6.8-1.6,16.6-3.2,28.5-3.2c12.1,0,22,1.7,28.8,3.2c0.1,0,0.7,0,1.2,0.4 c0.3,0.2,0.5,0.5,0.5,0.9c0,0.7-0.7,1.3-1.7,1.3c-6.6-1.6-16.5-3.4-28.7-3.4c-12.2,0-22,1.8-28.7,3.4 C93,137.9,92.3,137.4,92.3,136.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2dsl",
    d: "M151.1,107.3c0-0.7,0.6-1.3,1.4-1.3c5.7-1.6,14-3.2,24.1-3.2c10.2,0,18.6,1.7,24.4,3.2c0.1,0,0.6,0,1,0.4 c0.3,0.2,0.4,0.5,0.4,0.9c0,0.7-0.6,1.3-1.4,1.3c-5.6-1.6-14-3.4-24.3-3.4c-10.3,0-18.7,1.8-24.3,3.4 C151.7,108.4,151.1,107.9,151.1,107.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2dsl",
    d: "M101,107.3c0-0.7,0.6-1.3,1.4-1.3c5.7-1.6,14-3.2,24.1-3.2c10.2,0,18.6,1.7,24.4,3.2c0.1,0,0.6,0,1,0.4 c0.3,0.2,0.4,0.5,0.4,0.9c0,0.7-0.6,1.3-1.4,1.3c-5.6-1.6-14-3.4-24.3-3.4c-10.3,0-18.7,1.8-24.3,3.4 C101.6,108.4,101,107.9,101,107.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2dsl",
    d: "M151.9,147.9h-0.1c-0.7,0-1.2-0.5-1.2-1.2v-8.9c0-0.7,0.5-1.2,1.2-1.2h0.1c0.7,0,1.2,0.5,1.2,1.2v8.9 C153.1,147.3,152.5,147.9,151.9,147.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2dsl",
    d: "M151.4,144.9c0.4,0.7,1.1,1.6,2.2,2.4c3.7,2.5,9.1,1.5,12.1,1c8-1.5,8.2-4.3,16.4-6.5c2-0.5,6.9-1.7,13.2-1.4 c6.8,0.3,12,2,15,3.2c-0.1,0.8-0.2,1.6-0.3,2.4c-2.7-1.2-7.8-3.2-14.7-3.5c-6-0.3-10.8,0.9-13.6,1.7c-10.3,6.5-21.2,8.9-28,5.4 c-1.1-0.6-2.2-1.4-3.3-2.6C150.8,146.3,151.1,145.6,151.4,144.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2dsl",
    d: "M151.1,144.9c-0.4,0.7-1.2,1.6-2.4,2.4c-3.9,2.5-9.7,1.5-12.9,1c-8.5-1.5-8.7-4.3-17.5-6.5 c-2.2-0.5-7.4-1.7-14-1.4c-7.2,0.3-12.7,2-15.9,3.2c0.1,0.8,0.2,1.6,0.3,2.4c2.9-1.2,8.3-3.2,15.6-3.5c6.4-0.3,11.5,0.9,14.4,1.7 c10.9,6.5,22.6,8.9,29.7,5.4c1.2-0.6,2.4-1.4,3.5-2.6C151.8,146.3,151.5,145.6,151.1,144.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2dsl",
    d: "M139.9,204c0,0.7-0.6,1.3-1.4,1.3c-5.7,1.6-14,3.2-24.1,3.2c-10.2,0-18.6-1.7-24.4-3.2c-0.1,0-0.6,0-1-0.4 c-0.3-0.2-0.4-0.5-0.4-0.9c0-0.7,0.6-1.3,1.4-1.3c5.6,1.6,14,3.4,24.3,3.4c10.3,0,18.7-1.8,24.3-3.4 C139.3,202.9,139.9,203.4,139.9,204z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2dsl",
    d: "M137.2,194.5c0,0.7-0.6,1.3-1.4,1.3c-5.7,1.6-14,3.2-24.1,3.2c-10.2,0-18.6-1.7-24.4-3.2c-0.1,0-0.6,0-1-0.4 c-0.3-0.2-0.4-0.5-0.4-0.9c0-0.7,0.6-1.3,1.4-1.3c5.6,1.6,14,3.4,24.3,3.4c10.3,0,18.7-1.8,24.3-3.4 C136.6,193.4,137.2,194,137.2,194.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2dsl",
    d: "M157.9,203c0,0.7,0.6,1.3,1.4,1.3c5.7,1.6,14,3.2,24.1,3.2c10.2,0,18.6-1.7,24.4-3.2c0.1,0,0.6,0,1-0.4 c0.3-0.2,0.4-0.5,0.4-0.9c0-0.7-0.6-1.3-1.4-1.3c-5.6,1.6-14,3.4-24.3,3.4c-10.3,0-18.7-1.8-24.3-3.4 C158.5,201.9,157.9,202.4,157.9,203z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2dsl",
    d: "M160.6,193.5c0,0.7,0.6,1.3,1.4,1.3c5.7,1.6,14,3.2,24.1,3.2c10.2,0,18.6-1.7,24.4-3.2c0.1,0,0.6,0,1-0.4 c0.3-0.2,0.4-0.5,0.4-0.9c0-0.7-0.6-1.3-1.4-1.3c-5.6,1.6-14,3.4-24.3,3.4c-10.3,0-18.7-1.8-24.3-3.4 C161.2,192.4,160.6,193,160.6,193.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2dsl",
    d: "M173.4,171.7c0,0.7,0.4,1.3,0.9,1.3c3.5,1.6,8.6,3.2,14.7,3.2c6.2,0,11.3-1.7,14.9-3.2c0.1,0,0.4,0,0.6-0.4 c0.2-0.2,0.3-0.5,0.3-0.9c0-0.7-0.4-1.3-0.9-1.3c-3.4,1.6-8.5,3.4-14.8,3.4c-6.3,0-11.4-1.8-14.8-3.4 C173.8,170.6,173.4,171.1,173.4,171.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2dsl",
    d: "M127.2,171.7c0,0.7-0.4,1.3-0.9,1.3c-3.5,1.6-8.6,3.2-14.7,3.2c-6.2,0-11.3-1.7-14.9-3.2 c-0.1,0-0.4,0-0.6-0.4c-0.2-0.2-0.3-0.5-0.3-0.9c0-0.7,0.4-1.3,0.9-1.3c3.4,1.6,8.5,3.4,14.8,3.4c6.3,0,11.4-1.8,14.8-3.4 C126.8,170.6,127.2,171.1,127.2,171.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3dsl",
    d: "M258.4,240.2c-7.6-15.6-15.9-36.4-21.6-61.7c-5.3-23.7-6.8-44.8-6.8-61.4c-0.2-4.4-3.1-48.7-39.3-70.3 c-16-9.5-31.9-10.7-40.8-10.6c-8.8-0.1-24.8,1.1-40.8,10.6C73,68.3,70.2,112.6,70,117c0,16.6-1.5,37.7-6.8,61.4 c-5.7,25.3-14,46.1-21.6,61.7c22.1,0,44.1,0,66.2,0c-27.3-55-23-109.4,5.6-132.6c5.9-4.8,17.1-11.8,36.6-13 c19.5,1.2,30.8,8.2,36.6,13c28.6,23.2,32.9,77.6,5.6,132.6C214.3,240.2,236.4,240.2,258.4,240.2z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarthSidiusLogo);
export default __webpack_public_path__ + "static/media/darth-sidius-logo.2996eb3a.svg";
export { ForwardRef as ReactComponent };